<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { FhLink, FhText, FhCard, FhTitle } from '@fareharbor-com/beacon-vue';
import LoginForm from '@/components/LoginForm/LoginForm.vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import { config } from '@/configs';
import { InventoryEnvironment } from '@/types/InventoryEnvironment';

const URLS = {
  REGISTER_FORM:
    'https://fareharbor.com/become-an-affiliate/signup/?ref=marketplace',
};

const currentEnvironment = config.ENVIRONMENT;
const isStagingOrLocal = computed(() =>
  [InventoryEnvironment.STAGING, InventoryEnvironment.LOCAL].includes(
    currentEnvironment,
  ),
);

const router = useRouter();

const topBlurClass = computed(() =>
  isStagingOrLocal.value ? 'top-10' : 'top-0',
);
const loginFormHeight = computed(() =>
  isStagingOrLocal.value ? 'calc(100vh - 165px)' : 'calc(100vh - 150px)',
);
</script>

<template>
  <BaseFlexbox :style="{ height: loginFormHeight }">
    <div
      :class="[
        'flex flex-col fixed inset-x-0 z-50 flex justify-center items-center w-full h-screen backdrop-blur-sm ',
        topBlurClass,
      ]"
    >
      <BaseFlexbox
        justifyContent="center"
        class="relative w-full max-w-md p-6 border-gray-300"
      >
        <img
          src="@/assets/images/logo.png"
          alt="Marketplace Logo"
          class="h-14"
        />
      </BaseFlexbox>
      <FhCard
        elevated
        size="lg"
        class="bg-white shadow-lg rounded-lg overflow-hidden w-full max-w-md"
      >
        <FhTitle variant="display-lg">Login</FhTitle>
        <LoginForm />
        <div class="text-sm font-medium text-gray-500 mt-4">
          <div class="flex flex-col items-start space-y-1">
            <FhText tag="span" variant="body-sm">
              Forgot your password?
              <FhLink
                variant="primary"
                @click.prevent="router.push({ name: 'request-password-reset' })"
                data-test-id="request-password-reset-link"
                href="#"
              >
                Request password reset
              </FhLink>
            </FhText>
            <FhText tag="span" variant="body-sm">
              Not registered?
              <FhLink
                variant="primary"
                data-test-id="contact-support-link"
                target="_blank"
                :href="URLS.REGISTER_FORM"
              >
                Contact Support
              </FhLink>
            </FhText>
          </div>
        </div>
      </FhCard>
    </div>
  </BaseFlexbox>
</template>
